/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:51:06
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 19:34:40
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/HOC/DataProcessHOC.tsx
 */
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { onContentErrorHooks } from 'src/constrains/DraggableModules/tools';
import { useErrorOnChange2 } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
//import { useError } from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/hooks';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';

const DataProcessHOC = (Component: any, obj?: any) => {
  const WrappedComponent = (props) => {
    const {
      droppableId,
      draggableId,

      getContent,
      //To Do Delete Link Temp
      getErrorDisplay,

      onErrorChange,
      getCollapseStatus,
      extraProps,
      ...rest
    } = props;
    //console.log('extraProps', extraProps);

    const _d = useDispatch();
    const _e: any = useSelector(getErrorDisplay(draggableId));
    const { display: _display, hasError: _hasError } = _e;

    const isOpen = useSelector(getCollapseStatus(draggableId));

    const _data: any = useSelector(getContent(draggableId));
    const { staticData, dynamicData } = _data;
    //console.log('_data', _data);

    const {
      //currentSpecificError,
      // currentGeneralError,
      specificError, //->对应现在应该显示error,对应pDataError里面的数据
      generalError, //->对应现在应该显示error,对应pDataError里面的数据
      // currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
      currentHasError,
    } = onContentErrorHooks({
      data: _data,
      isOpen,
      display: _display,
      validationProps: { ...(extraProps || {}) },
    });
    // console.log('specificError', specificError);
    useErrorOnChange2({
      latestHasError: currentHasError,
      previousHasError: _hasError,
      dispatch: _d,
      action: onErrorChange,
      id: draggableId,
    });

    // const {
    //   specificError, //->对应现在应该显示error,对应pDataError里面的数据
    //   generalError, //->对应现在应该显示error,对应pDataError里面的数据
    //   currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
    //   currentHasError,
    // } = useError({
    //   data: _data,
    //   open: _open,
    //   display: _display,
    //   validation: validation
    //     ? (x) => {
    //         return validation(x, { isPrimary });
    //       }
    //     : null,
    //   isPrimary,
    //   stamp,
    //   errorDisplayHasError: _hasError,
    //   onErrorChange,
    //   id,
    //   isRedux: true,
    // });

    const returnProps = {
      staticData,
      dynamicData,
      specificError: specificError || {},
      droppableId: droppableId,
      draggableId: draggableId,
      extraProps,
      ...rest,
      //   ...props,
    };

    return (
      <GeneralCollapseContent err={generalError || []}>
        <Component {...returnProps} />
      </GeneralCollapseContent>
    );
  };
  return WrappedComponent;
};
export default DataProcessHOC;
